<template>
  <div id="drag" class="enabl" @mousedown="mouseDown">
    <div class="contListWid">
      <p style="background-color: yellow;"><span></span><span></span><span></span></p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "dragHolder",
    data() {
      return {
        lastX: ""
      };
    },

    created() {
      document.addEventListener("mouseup", this.mouseUp);
    },

    destroyed() {
      document.removeEventListener("mouseup", this.mouseUp);
    },

    methods: {
      mouseDown(event) {
        document.addEventListener("mousemove", this.mouseMove);
        this.lastX = event.screenX;
      },
      mouseMove(event) {
        this.$emit("widthChange", this.lastX - event.screenX);
        this.lastX = event.screenX;
      },
      mouseUp() {
        this.lastX = "";
        document.removeEventListener("mousemove", this.mouseMove);
      }
    }
  };
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sub/dragHolder.vue